function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactDOM from 'react-dom';
import { LocaleProvider, ThemeProvider } from 'oskari-ui/util';
import { LayerViewTabs, LayerViewTabsHandler, TABS_ALL_LAYERS, TABS_SELECTED_LAYERS } from './view/LayerViewTabs/';
import { LAYER_GROUP_TOGGLE_LIMIT, LAYER_GROUP_TOGGLE_DEFAULTS, BACKEND_STATUS_AVAILABLE } from './constants';

/**
 * @class Oskari.mapframework.bundle.layerlist.Flyout
 *
 * Renders the "all layers" flyout.
 */
Oskari.clazz.define('Oskari.mapframework.bundle.layerlist.Flyout',
/**
 * @method create called automatically on construction
 * @static
 * @param {Oskari.mapframework.bundle.layerlist.LayerListBundleInstance} instance
 *    reference to component that created the flyout
 */
function (instance) {
  var _this = this;
  this.instance = instance;
  // the show "add all layers to map" control for groups is disabled by default. Use instance conf to enable it.
  // view/bundle modifier adds backend status available conf if bundle is present
  var defaultOpts = _defineProperty(_defineProperty({}, LAYER_GROUP_TOGGLE_LIMIT, LAYER_GROUP_TOGGLE_DEFAULTS.DISABLE_TOGGLE), BACKEND_STATUS_AVAILABLE, false);
  var instanceConf = this.instance.conf || {};
  this.optsForUI = _objectSpread(_objectSpread({}, defaultOpts), instanceConf);
  this.container = null;
  this.tabsHandler = new LayerViewTabsHandler(this.instance);
  this.tabsHandler.getLayerListHandler().loadLayers();
  this.tabsHandler.addStateListener(function () {
    return _this.render();
  });
}, {
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.layerlist.Flyout';
  },
  /**
   * @method setEl
   * @param {Object} el
   *     reference to the container in browser
   * @param {Number} width
   *     container size(?) - not used
   * @param {Number} height
   *     container size(?) - not used
   *
   * Interface method implementation
   */
  setEl: function setEl(el, flyout, width, height) {
    this.container = el[0];
    if (!jQuery(this.container).hasClass('layerlist')) {
      jQuery(this.container).addClass('layerlist');
    }
    if (!flyout.hasClass('layerlist')) {
      flyout.addClass('layerlist');
    }
  },
  /**
   * Interface method implementation, does nothing atm
   * @method startPlugin
   */
  startPlugin: function startPlugin() {
    this.render();
  },
  /**
   * @method stopPlugin
   *
   * Interface method implementation, does nothing atm
   */
  stopPlugin: function stopPlugin() {},
  /**
   * @method getTitle
   * @return {String} localized text for the title of the flyout
   */
  getTitle: function getTitle() {
    return this.instance.getLocalization('title');
  },
  /**
   * @method getDescription
   * @return {String} localized text for the description of the flyout
   */
  getDescription: function getDescription() {
    return this.instance.getLocalization('desc');
  },
  /**
   * For request handler. This is used when opening the layerlist from outside this bundle.
   * @param {string} activeFilterId
   */
  setActiveFilter: function setActiveFilter(activeFilterId, showSelectedLayers) {
    var filterHandler = this.tabsHandler.getLayerListHandler().getFilterHandler();
    filterHandler.stashCurrentState();
    filterHandler.updateState({
      activeFilterId: activeFilterId,
      searchText: null
    });
    var activeTab = showSelectedLayers ? TABS_SELECTED_LAYERS : TABS_ALL_LAYERS;
    this.tabsHandler.setTab(activeTab);
  },
  /**
   * @method render
   * Renders React content
   */
  render: function render() {
    if (!this.container) {
      return;
    }
    var content = /*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: this.instance.getName()
      }
    }, /*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(LayerViewTabs, _extends({}, this.tabsHandler.getState(), {
      opts: this.optsForUI,
      controller: this.tabsHandler.getController()
    }))));
    ReactDOM.render(content, this.container);
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  protocol: ['Oskari.userinterface.Flyout']
});